Customer.Users ||= {}

class Customer.Users.GooglePlayProfileView extends Backbone.View

  template: JST["backbone/templates/customer/users/google_play_profile"]

  className: 'social-profile'
  id: 'google_play-profile'

  events:
    'click .remove-profile-button': 'removeSocialUser'

  initialize: (socialUser) ->
    @socialUser = socialUser

  render: ->
    @$el.html(@template(socialUser: @socialUser))
    @

  removeSocialUser: ->
    @trigger('profile:remove-social-user', @socialUser)